import { Pipe, PipeTransform } from '@angular/core';
import { StringHelpers } from '@lockton-apps/shared/util/helpers';
import { defaults } from 'lodash';
import { EndorsementMeta } from '@lockton-apps/shared/interfaces';
import { EndorsementMetaService } from '@lockton-apps/shared/util/constants';

@Pipe({
  name: 'endorsementMeta',
  standalone: true,
})
export class EndorsementMetaPipe implements PipeTransform {
  constructor(
    private readonly endorsementMetaService: EndorsementMetaService
  ) {}

  transform(
    type: number,
    params: Record<string, unknown> = {}
  ): EndorsementMeta {
    const meta: EndorsementMeta = this.endorsementMetaService.get(type);

    return defaults(
      {
        template: {
          title: StringHelpers.interpolate(meta.template.title, params, true),
          description: StringHelpers.interpolate(
            meta.template.description,
            params,
            true
          ),
        },
      },
      meta
    );
  }
}
